import { render, staticRenderFns } from "./travel-document-form.vue?vue&type=template&id=1728b45e&"
import script from "./travel-document-form.vue?vue&type=script&lang=js&"
export * from "./travel-document-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports